import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export interface IState {
  progressValue?: number
  currentStep?: number
  totalSteps?: number
  currentStepName?: string
  color?: 'blue' | 'purple'
  enableNewTestPage?: boolean
  toggleVersion?: string
}

@Injectable({
  providedIn: 'root'
})
export class SharedStateService {
  public initialState: IState = {
    progressValue: 0,
    currentStep: 0,
    totalSteps: 0,
    currentStepName: '',
    color: 'blue',
    enableNewTestPage: true,
    toggleVersion: '1.01' // Must change the version while adding new toggle key
  }
  readonly timeFormat = 'YYYY-MM-DD HH:mm'
  public state$ = new BehaviorSubject<IState>(this.initialState)
  private bookingObject = 'bookingObject'
  constructor (
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    const local = this.getFromLocalStorage()
    if (local && (Object.keys(local)?.length) && this.initialState?.toggleVersion === local?.toggleVersion) {
      this.state$.next({
        ...local
      } as IState)
    } else {
      this.state$.next(this.initialState)
      localStorage.setItem(this.bookingObject, JSON.stringify(this.initialState))
    }
  }

  getFromLocalStorage () {
    const bookingObj = localStorage.getItem(this.bookingObject)
    return bookingObj ? JSON.parse(bookingObj) : ''
  }

  changeState (myChange: IState) {
    this.state$.next(myChange)
    const temp = JSON.stringify({
      ...myChange
    })
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.bookingObject, temp)
    }
  }

  updateState (myChange: IState) {
    const newState = {
      ...this.state$.getValue(),
      ...myChange
    }
    this.state$.next(newState)
    const temp = JSON.stringify(newState)
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.bookingObject, temp)
    }
  }

  getState () {
    return this.state$.asObservable()
  }
  clearLocalStorage () {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(this.bookingObject)
    }
    this.state$.next(this.initialState)
    localStorage.setItem(this.bookingObject, JSON.stringify(this.initialState))
  }
  clearState () {
    this.state$.next(this.initialState)
  }
}
